import axios from "axios";

const PUBLIC_ROUTES = [
  "/",
  "login",
  "forgot-password",
  "otp-page",
  "otp-change-password",
  "page-change-password",
  "register",
  "documentation",
  "home-page",
  "syarat-ketentuan",
  "information",
  "download",
  "contact",
  "search",
  "verificationpage",
  "under-maintenance",
];

const checkAuth = () => {
  const TOKEN = localStorage.getItem("token");
  const isPublicPage = PUBLIC_ROUTES.some((r) =>
    window.location.href.includes(r)
  );

  localStorage.setItem("isOpenLayer", 1);

  // ===== Setup interceptor GLOBAL (sekali saja) =====
  setupInterceptors();

  if (!TOKEN && !isPublicPage) {
    // Belum login & di halaman privat → tendang ke /login
    window.location.href = "/login";
    return;
  }

  if (TOKEN) {
    axios.defaults.headers.common["Authorization"] = `Bearer ${TOKEN}`;
  }

  return TOKEN;
};

// Flag agar interceptor tidak terpasang berkali-kali
let interceptorsAttached = false;

const setupInterceptors = () => {
  if (interceptorsAttached) return;
  interceptorsAttached = true;

  // Loading indicator
  axios.interceptors.request.use(
    (config) => {
      document.body.classList.add("loading-indicator");
      return config;
    },
    (error) => Promise.reject(error)
  );

  axios.interceptors.response.use(
    (response) => {
      document.body.classList.remove("loading-indicator");
      return response;
    },
    (error) => {
      document.body.classList.remove("loading-indicator");

      const status = error.response?.status;
      const url = error.config?.url || "";

      // Endpoint auth jangan trigger redirect (biar form bisa tampilkan error)
      const isAuthEndpoint =
        url.includes("/login") ||
        url.includes("/forgot-password") ||
        url.includes("/register") ||
        url.includes("/otp");

      if (status === 401 && !isAuthEndpoint) {
        // Sesi hilang / expired
        localStorage.removeItem("token");
        localStorage.removeItem("user"); // sesuaikan jika ada

        // Hindari loop kalau sudah di /login
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }

      return Promise.reject(error);
    }
  );
};

export default checkAuth;